export const FETCH_BUILDING_INDICATORS = 'FETCH_BUILDING_INDICATORS'
export const FETCH_BUILDING_INDICATOR_TYPES = 'FETCH_BUILDING_INDICATOR_TYPES'
export const CREATE_BUILDING_INDICATOR = 'CREATE_BUILDING_INDICATOR'
export const UPDATE_BUILDING_INDICATOR = 'UPDATE_BUILDING_INDICATOR'
export const DELETE_BUILDING_INDICATOR = 'DELETE_BUILDING_INDICATOR'